/* ============================================
   Mi perfil (panel del partner) — solo la persona

   Tenía sub-navegación con "Datos de la empresa" adentro, y eso obligaba a
   entrar a *mi* perfil para cambiar algo que no es mío. La empresa, el equipo
   y las integraciones se fueron a Configuración.

   Lo que queda son dos cosas, y caben juntas: quién soy y cómo entro. Sin
   menú lateral para dos secciones —ocupaba 220 px para elegir entre dos— y en
   dos columnas, que es lo que llena la pantalla en vez de dejar una tarjeta
   angosta flotando.
   ============================================ */
import { Breadcrumbs } from '@/components/ui'
import { PerfilProvider } from '@/pages/portal/perfil/perfil-contexto'
import PerfilPersonal from '@/pages/portal/perfil/PerfilPersonal'
import PerfilSeguridad from '@/pages/portal/perfil/PerfilSeguridad'

export default function PartnerPerfil() {
  return (
    <PerfilProvider>
      <div className="portal-page-enter pp-wrap">
        <Breadcrumbs items={[{ label: 'Mi perfil' }]} />
        <div className="pp-dos-columnas">
          <PerfilPersonal />
          <PerfilSeguridad />
        </div>
      </div>
    </PerfilProvider>
  )
}
